import React, { Component } from 'react'
import { Link } from "react-scroll";

import Images from '../helpers/images'
import logo from '../../assets/images/la-piquera.svg'
import { site } from '../../lib/text'


class Header extends Component {

    handleAnimation = () => {
        const header = document.getElementById('header')
        if (document.documentElement.scrollTop > 50) {           
            //console.log(document.documentElement.scrollTop);
            header.classList.add('animation')
        } else {
            header.classList.remove('animation')
        }
    }

    componentDidMount() {    
        window.onscroll = () => this.handleAnimation()
    }

    render(){
        return (
            <header id="header">
                <div className="container">
                    <div className="header--logo">
                        <Images url={logo} txt={site} />
                    </div>
                    <div className="header--button">
                        <Link
                            className="button"
                            activeClass="active"
                            to="footer"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            rel="noopener noreferrer"
                            aria-label="Escribinos"
                        >Escribinos =)</Link>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header